import React from 'react';
import PropTypes from 'prop-types';
import ChosenSelect from './ChosenSelect';

const CarsFilter = ({ options, value, onChange }) => (
  <div className="carSelection">
    <div className="chartControlTitle" data-testid="analysis-filters-panel-cars-label">Cars</div>
    <div className="input-group carSelectorGroup">
      <i className="fas fa-search input-group-addon" />
      <ChosenSelect
        options={options}
        value={(value || []).map(option => option.value)}
        multiple
        className="carSelect"
        onChange={selectedValues => onChange(options.filter(option => selectedValues.includes(String(option.value))))}
        testId="analysis-filters-panel-cars-select"
      />
      <span className="input-group-addon" title="Clear selection">
        <button type="button" className="analysis-filter-clear" aria-label="Clear cars selection"
          onClick={() => onChange([])} data-testid="analysis-filters-panel-cars-clear">
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      </span>
    </div>
  </div>
);

CarsFilter.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CarsFilter;